import React, { useState, useEffect } from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Crown, CheckCircle, Zap, Star, Lock } from 'lucide-react';
import { walletAPI } from '../../services/api';

const PLANS = [
  {
    id: 'gratis',
    name: 'Gratis',
    price: 0,
    color: 'border-gray-200',
    features: ['5 productos', '1 campana publicitaria', 'Soporte basico'],
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 299,
    color: 'border-orange-400',
    badge: 'Popular',
    features: ['50 productos', '10 campanas', 'Analytics avanzados', 'Soporte prioritario'],
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 999,
    color: 'border-purple-400',
    features: ['Productos ilimitados', 'Campanas ilimitadas', 'API access', 'Soporte dedicado'],
  },
];

const UserSubscription = () => {
  const [wallet, setWallet] = useState(null);

  useEffect(() => {
    walletAPI.getWallet().then(setWallet).catch(() => {});
  }, []);

  const currentPlan = wallet?.subscription_plan || 'gratis';
  const planStatus = wallet?.subscription_status || 'active';

  return (
    <div className="space-y-6" data-testid="user-subscription">
      {/* Current Plan */}
      <Card className="p-6 bg-gradient-to-br from-gray-50 to-white" data-testid="current-plan">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-orange-100">
            <Crown className="w-5 h-5 text-orange-500" />
          </div>
          <div>
            <h2 className="text-lg font-bold">Plan actual</h2>
            <p className="text-sm text-gray-500">Gestion de suscripcion</p>
          </div>
        </div>
        <div className="flex items-center gap-4 p-4 rounded-lg bg-white border">
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <span className="text-xl font-bold capitalize">{currentPlan}</span>
              <Badge className={`${planStatus === 'active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                <CheckCircle className="w-3 h-3 mr-1" />
                {planStatus === 'active' ? 'Activo' : 'Inactivo'}
              </Badge>
            </div>
            <p className="text-sm text-gray-500 mt-1">
              {currentPlan === 'gratis' ? 'Plan basico sin costo mensual' : `Suscripcion ${currentPlan}`}
            </p>
          </div>
        </div>
      </Card>

      {/* Plans Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {PLANS.map(plan => {
          const isCurrent = plan.id === currentPlan;
          return (
            <Card
              key={plan.id}
              className={`p-5 relative ${plan.color} border-2 ${isCurrent ? 'ring-2 ring-orange-400' : ''}`}
              data-testid={`plan-${plan.id}`}
            >
              {plan.badge && (
                <span className="absolute -top-3 left-4 px-3 py-0.5 rounded-full bg-orange-500 text-white text-xs font-bold">
                  {plan.badge}
                </span>
              )}
              <div className="mb-4">
                <h3 className="text-lg font-bold">{plan.name}</h3>
                <p className="text-3xl font-black mt-1">
                  {plan.price === 0 ? 'Gratis' : `$${plan.price}`}
                  {plan.price > 0 && <span className="text-sm font-normal text-gray-400">/mes</span>}
                </p>
              </div>
              <ul className="space-y-2 mb-5">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm text-gray-600">
                    <CheckCircle className="w-4 h-4 text-green-500 shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
              {isCurrent ? (
                <Button disabled className="w-full" variant="outline" data-testid={`btn-plan-${plan.id}`}>
                  Plan actual
                </Button>
              ) : (
                <Button
                  disabled
                  className="w-full bg-gray-100 text-gray-400 cursor-not-allowed"
                  data-testid={`btn-plan-${plan.id}`}
                >
                  <Lock className="w-4 h-4 mr-2" /> Proximamente
                </Button>
              )}
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default UserSubscription;
